import { Link } from 'react-router-dom';

const services = [
  {
    no: '01',
    title: '商業空間策略規劃',
    desc: '品牌定位、消費動線規劃、坪效配置、開店前空間方向建議，讓你在動工前就做對決策。',
    icon: 'ri-compass-3-line',
    tag: 'Strategy',
  },
  {
    no: '02',
    title: '商業空間設計',
    desc: '餐飲、零售、辦公、診所、展示等各類商業空間的完整設計方案，精準傳達品牌識別。',
    icon: 'ri-draft-line',
    tag: 'Design',
  },
  {
    no: '03',
    title: '裝修工程整合',
    desc: '設計到施工一條龍服務，整合工程、材料、預算與工期，確保落地品質與時程控管。',
    icon: 'ri-tools-line',
    tag: 'Construction',
  },
  {
    no: '04',
    title: '品牌升級 / 舊店翻新',
    desc: '老店空間重塑、品牌形象升級、局部改裝優化，以最合理的投入帶來最大的品牌效益。',
    icon: 'ri-refresh-line',
    tag: 'Renewal',
  },
];

export default function ServicesPreview() {
  return (
    <section className="py-24 md:py-32 bg-[#f4f2ef]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-4">Services</p>
            <h2
              className="font-bold text-[#1a1a1a] leading-[1.35]"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              四大核心服務
            </h2>
          </div>
          <Link
            to="/services"
            className="inline-flex items-center gap-2 text-[#b8956a] font-medium hover:gap-3 transition-all cursor-pointer whitespace-nowrap text-[1rem]"
          >
            查看完整服務說明
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <div
              key={i}
              className="bg-[#fafaf8] rounded-2xl p-8 flex flex-col gap-6 group hover:bg-[#1a1a1a] transition-colors duration-500 cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <span
                  className="font-display font-light text-[#e2ddd8] group-hover:text-white/20 transition-colors"
                  style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '3rem', lineHeight: 1 }}
                >
                  {s.no}
                </span>
                <span className="text-xs font-medium tracking-widest text-[#8a8a8a] group-hover:text-[#b8956a] uppercase transition-colors">
                  {s.tag}
                </span>
              </div>

              <div className="w-12 h-12 flex items-center justify-center border border-[#e2ddd8] group-hover:border-[#b8956a] rounded-xl transition-colors">
                <i className={`${s.icon} text-[#b8956a] text-xl`}></i>
              </div>

              <div>
                <h3
                  className="font-semibold text-[#1a1a1a] group-hover:text-white mb-3 leading-[1.45] transition-colors"
                  style={{ fontSize: '1.125rem' }}
                >
                  {s.title}
                </h3>
                <p className="text-[#5a5a5a] group-hover:text-white/60 text-sm leading-relaxed transition-colors">
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
